export const getAnalyticsUserId = (state) => state.analytics.analyticsUserId
